import { render, staticRenderFns } from "./MoreMenuItem.vue?vue&type=template&id=34fd2f42&scoped=true&"
import script from "./MoreMenuItem.vue?vue&type=script&lang=js&"
export * from "./MoreMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MoreMenuItem.vue?vue&type=style&index=0&id=34fd2f42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd2f42",
  null
  
)

export default component.exports